import { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";

// useSrfDetails hook
const formatDate = (date) => {
  if (!date) return null;
  let Newdate = moment(date).format("YYYY-MM-DD");
  return new Date(Newdate);
};

export const useSrfDetails = (initialState) => {
  const [srfDetails, setSrfDetails] = useState(initialState);

  const fetchSrfDetails = async (id,setClientContactData) => {
    try {

      let SQLQuery = { query: `SELECT srf.serviceReqNumber as srf_serviceReqNumber, srf.companyHierarchy as srf_companyHierarchy, srf.jobNumber as srf_jobNumber, srf.customerAnnextureFilePaths as srf_customerAnnextureFilePaths, srf.ducImages as srf_ducImages, srf.poNumber as srf_poNumber, srf.contactPersonDetails as srf_contactPersonDetails, srf.calType as srf_calType, srf.poDate as srf_poDate, srf.billingId as srf_billingId, srf.receiptDate as srf_receiptDate, srf.committedDeliveryDate as srf_committedDeliveryDate, srf.dcNumber as srf_dcNumber, srf.dcDate as srf_dcDate, srf.entryDate as srf_entryDate, srf.description as srf_description, srf.address as srf_address, srf.billingAddress as srf_billingAddress,srf.reservedSrf as srf_reservedSrf, client.contact as client_contact, client.address as client_address, client.id as client_id, client.companyName as client_companyName FROM srfs as srf JOIN clients as client ON (srf.clientId = client.id) WHERE srf.id = ${id}` };


      const res = await axiosWithToken.post(
        `${BASE_URL}dynamic`,SQLQuery,
        { headers: { requestType: "fetchData" } }
      );
      const data = res.data[0];
      const _srfObject = {
        id: Number(id || 0),
        clientId: data.client_id,
        serviceReqNumber: data?.srf_serviceReqNumber,
        companyHierarchy: data?.srf_companyHierarchy,
        jobNumber: data?.srf_jobNumber,
        poNumber: data?.srf_poNumber,
        calType: Number(data?.srf_calType),
        poDate: formatDate(data.srf_poDate),
        receiptDate: formatDate(data.srf_receiptDate),
        committedDeliveryDate: formatDate(data.srf_committedDeliveryDate),
        dcNumber: data.srf_dcNumber,
        reservedSrf: data.srf_reservedSrf,
        dcDate: formatDate(data.srf_dcDate),
        multiDcDate: data.srf_multiDcDate,
        entryDate: formatDate(data.srf_entryDate),
        description: data.srf_description,
        address: data.srf_address,
        contactPersonDetails: data.srf_contactPersonDetails ? JSON.parse(data.srf_contactPersonDetails) : "",
        companyName: data.client_companyName,
        billingId: data?.srf_billingId,
        billingAddress: data?.srf_billingAddress,
        customerAnnextureFilePaths:
          data?.srf_customerAnnextureFilePaths?.split(",") || [],
        ducImages: data?.srf_ducImages?.split(",") || [],
      };
      setSrfDetails(_srfObject);
      sessionStorage.setItem("oldSrfDetails", JSON.stringify(_srfObject));
      const clientContactData=data.client_contact ? JSON?.parse(data.client_contact):[]
      setClientContactData(clientContactData);
    } catch (err) {
      console.error("Something Went Wrong at (fetchSrfDetails) : ", err);
    }
  };

  const updateSrfDetails = (details) => {
    setSrfDetails((prevState) => ({ ...prevState, ...details }));
  };

  return [srfDetails, updateSrfDetails, fetchSrfDetails];
};

export const fetchDescriptionRows = async (id, dispatch) => {
  try {
    dispatch({
      field: "loadingDUCInward",
      value: true,
    });
    let url = BASE_URL;
    let SQLQuery = { query: `SELECT * FROM srfInstruments WHERE srfsId = ${id} AND status = 1` };
    let SQLQuery1 = { query: `SELECT * FROM settings WHERE keyName = 'srfInstrumentsAdditionalColumns' AND status = 1` };

    const [instrumentsResponse, settingsResponse] = await Promise.all([
      axiosWithToken.post(`${url}dynamic`, SQLQuery, { headers: { requestType: "fetchData" } }),
      axiosWithToken.post(
        `${url}dynamic`,
        SQLQuery1,
        { headers: { requestType: "fetchData" } }
      ),
    ]);

    const instrumentsData = instrumentsResponse?.data || [];
    const extraColumnFromSetting = settingsResponse?.data?.[0]?.value;
    const extraColumnsKeys = extraColumnFromSetting?.split(",") || [];

    let rows = instrumentsData.map((row) => {
      let extraData = row?.extraColumns && JSON.parse(row?.extraColumns || {});

      const newRow = {
        id: row.id,
        instrumentId: Number(row.instrumentId),
        requestedDucName: row.requestedDucName,
        DUCID: row.DUCID,
        serialNumber: row.serialNumber,
        ranges: row.ranges,
        lc: row.lc,
        make: row.make,
        model: row.model,
        department: row.department,
        operatingRange: row.operatingRange,
        ConOfDuc: row.ConOfDuc,
        calFrequency: row.calFrequency,
        accuracy: row.accuracy,
        calibrationType: row.calibrationType,
        location: row.location,
        locationOfInstrument: row.locationOfInstrument,
        calPoint: row.calPoint,
        calMethod: row.calMethod,
        materialType: row.materialType,
        sensorType: row.sensorType,
        sensorCoefficient: row.sensorCoefficient ? row.sensorCoefficient : "",
        labCapabilities: row.labCapabilities,
        mpe: row.mpe,
        extraColumns: {},
      };

      extraColumnsKeys.forEach((key) => {
        newRow.extraColumns[key] = extraData[key] || "";
      });

      return newRow;
    });

    dispatch({
      field: "ducInwardRows",
      value: [...rows],
    });
    const oldRowsDucInward = JSON.parse(
      JSON.stringify(
        rows.map((row) => ({
          ...row,
          extraColumns: JSON.stringify(row.extraColumns),
        }))
      )
    );

    dispatch({
      field: "ducInwardOriginalRows",
      value: [...oldRowsDucInward],
    });
    sessionStorage.setItem("oldSrfInstruments", JSON.stringify(rows));
    dispatch({
      field: "loadingDUCInward",
      value: false,
    });
  } catch (error) {
    dispatch({
      field: "loadingDUCInward",
      value: false,
    });
    console.error("Error while fetching or processing data: ", error);
    if (error.message !== "request_aborted") {
      toast.error("Error while fetching or processing data");
    }
  }
};

// useInstruments hook
const initiateInstrumentList = (instrumentArray) => {
  var pushIArray = [];
  for (let i = 0; i < instrumentArray.length; i++) {
    if (instrumentArray[i].instrumentName) {
      pushIArray.push({
        label: instrumentArray[i].id + ", " + instrumentArray[i].instrumentName,
        id: instrumentArray[i].id,
        discipline: instrumentArray[i].name,
        calibrationProcedureNo: instrumentArray[i].calibrationProcedureNo,
      });
    }
  }
  return pushIArray;
};

export const useInstruments = (initialState) => {
  const [instrumentArray, setInstrumentArray] = useState(initialState);
  const [instrumentList, setInstrumentList] = useState([]);
  const [assignInstrumentIds, setAssignInstrumentIds] = useState("");

  const [userId, setUserId] = useState(localStorage.getItem("id"));
  const [userType, setUserType] = useState(localStorage.getItem("type"));

  const fetchInstrumentsList = (params) => {
    if (params?.filterWithDucMaster) {
      let query = `SELECT instruments.* FROM (SELECT DISTINCT instrumentId FROM ducMaster WHERE clientId = ${
        params?.clientId || 0
      }) AS ducMaster LEFT JOIN instruments ON ducMaster.instrumentId = instruments.id ${
        userType == 2 && assignInstrumentIds
          ? `WHERE instruments.id IN (${assignInstrumentIds})`
          : ""
      }`;

      axiosWithToken
        .post(
          BASE_URL + "dynamic",
          { query: query },
          { headers: { requestType: "fetchData" } }
        )
        .then((res) => {
          setInstrumentArray([...res.data]);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    } else {
      let SQLQuery = {
        query: `SELECT ins.c1 as ins_c1, ins.c2 as ins_c2, ins.c3 as ins_c3, ins.c4 as ins_c4, ins.c5 as ins_c5, ins.c6 as ins_c6, ins.c7 as ins_c7, ins.c8 as ins_c8, ins.c9 as ins_c9, ins.c10 as ins_c10, ins.calProcRefNo as ins_calProcRefNo, ins.calibrationProcedureNo as ins_calibrationProcedureNo, ins.calMethod as ins_calMethod, ins.cmcMinus as ins_cmcMinus, ins.cmcPlus as ins_cmcPlus, ins.disciplineId as ins_disciplineId, ins.id as ins_id, ins.instrumentName as ins_instrumentName, ins.isGauge as ins_isGauge, ins.lastModified as ins_lastModified, ins.materialType as ins_materialType, ins.referenceStandards as ins_referenceStandards, ins.standardMasterIds as ins_standardMasterIds, ins.status as ins_status, ins.supportiveInstrumentMasterData as ins_supportiveInstrumentMasterData, ins.uncertaintyFactors as ins_uncertaintyFactors, ins.uncertaintyMasterData as ins_uncertaintyMasterData, d.name as d_name 
        FROM instruments as ins 
        JOIN discipline as d ON (ins.disciplineId = d.id) 
        WHERE ins.status = 1
        ${userType == 2 && assignInstrumentIds ? `AND ins.id IN (${assignInstrumentIds})` : ""}`
      };
      
      axiosWithToken
        .post(
          BASE_URL +
            `dynamic`,SQLQuery,
          { headers: { requestType: "fetchData" } }
        )
        .then((res) => {
          let d = JSON.stringify(res.data)
            .replaceAll("ins_", "")
            .replaceAll("d_", "");
          res.data = JSON.parse(d);
          setInstrumentArray([...res.data]);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    }
  };

  const getInstrument = (id) => {
    for (let instrument in instrumentList) {
      if (instrumentList[instrument].id == id)
        return instrumentList[instrument];
    }
    return null;
  };

  const getAssignedInstrumentForEngineer = (userId) => {
    let SQLQuery = { query: `SELECT * FROM assignedDucs WHERE userId = ${userId} AND status = 1` };

    axiosWithToken
      .post(
        BASE_URL + `dynamic`,SQLQuery,
        { headers: { requestType: "fetchData" } }
      )
      .then((res) => {
        setAssignInstrumentIds(res.data?.[0]?.instrumentIds);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  useEffect(() => {
    if (userType == 2) getAssignedInstrumentForEngineer(userId);
    setInstrumentList(initiateInstrumentList(instrumentArray));
  }, [userId, instrumentArray, userType]);

  return [instrumentList, instrumentArray, fetchInstrumentsList, getInstrument];
};

// useClient hook
export const fetchClientIdList = (setClientArray) => {
  let url = BASE_URL;
  let userType = localStorage.getItem("type");
  let branch = localStorage.getItem("branch");
  let validClients = localStorage.getItem("validClients");
  let branchWhere = () => {
    if (branch && branch !== "null" && branch !== "undefined")
      return `AND c.branch IN (${branch})`;
    return "";
  };

  let SQLQuery = { 
    query: `SELECT c.address as c_address, c.branch as c_branch, c.companyName as c_companyName, c.contact as c_contact, c.email as c_email, c.gstNumber as c_gstNumber, c.id as c_id, c.lastModified as c_lastModified, c.matrixId as c_matrixId, c.shippingAddress as c_shippingAddress, c.signature as c_signature, c.state as c_state, c.status as c_status, c.uniCode as c_uniCode, b.branchName as b_branchName 
            FROM clients as c 
            JOIN branch as b ON (c.branch = b.id) 
            WHERE c.status = 1 
            ${userType == 1 ? "" : userType == 4 ? branchWhere() : validClients?.length > 0 ? `${branchWhere()} AND c.id IN (${validClients})` : branchWhere()}` 
  };

  axiosWithToken
    .post(
      url +
        `dynamic`,SQLQuery
      // { headers: { requestType: "fetchData" } }
    )
    .then((res) => {
      let d = (res.data = JSON.stringify(res.data)
        .replaceAll("c_", "")
        .replaceAll("b_", ""));
      res.data = JSON.parse(d);
      setClientArray(res.data);
    })
    .catch((error) => {
      console.log("error",error)
      if (error.message !== "request_aborted") {
        toast.error("Failed to fetch client list");
      }
      // console.log({ error });
    });
};

// use unit master hook
export const useUnitMaster = (initialState) => {
  const [unitArray, setUnitArray] = useState(initialState);
  const [unitFilter, setUnitFilter] = useState([]);

  const fetchUnitMaster = () => {
    let url = BASE_URL;
    let SQLQuery = { query: `SELECT * FROM unit WHERE status = 1` };

    axiosWithToken
      .post(url + "dynamic", SQLQuery, {
        headers: { requestType: "fetchData" }})
      .then((res) => {
        setUnitArray([""].concat(res.data));
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const UnitList = () => {
    var uArr = [];
    for (let i = 0; i < unitArray.length; i++) {
      uArr.push({
        label: unitArray[i].id + ", " + unitArray[i].symbol,
      });
    }
    setUnitFilter(uArr);
  };

  useEffect(() => {
    UnitList();
  }, [unitArray]);

  return [unitArray, unitFilter, setUnitFilter, fetchUnitMaster];
};

export const useSettings = (initialState) => {
  const [settings, setSettings] = useState(initialState);

  const fetchSettings = (keys) => {
 
    let url = BASE_URL;
    let SQLQuery = { query: `SELECT id, keyName, value FROM settings WHERE (${keys?.map((key) => `keyName = '${key}'`)?.join(" OR ")}) AND (status = 1 OR status = -2)` };

    axiosWithToken
      .post(
        url +
          `dynamic`,SQLQuery,
        { headers: { requestType: "fetchData" } }
      )
      .then((res) => {
        let data = {};
        res.data.forEach((e) => {
          data[e.keyName] = e;
        });

        setSettings({
          ...settings,
          ...data,
        });
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Failed to fetch settings");
        }
      });
  };

  return [settings, fetchSettings];
};

export const fetchSettings = (keysToFetch, settings, dispatch) => {

  let url = BASE_URL;
  let SQLQuery = { query: `SELECT id, keyName, value FROM settings WHERE (${keysToFetch?.map((key) => `keyName = '${key}'`)?.join(" OR ")}) AND (status = 1 OR status = -2)` };

  axiosWithToken
    .post(
      url +
        `dynamic`,SQLQuery,
      { headers: { requestType: "fetchData" } }
    )
    .then((res) => {
      let data = {};
      res.data.forEach((e) => {
        data[e.keyName] = e;
      });

      dispatch({
        field: "settings",
        value: {
          ...settings,
          ...data,
        },
      });
    })
    .catch((error) => {
      if (error.message !== "request_aborted") {
        toast.error("Failed to fetch settings");
      }
    });
};

export const fetchCSRFFormData = async (id) => {
  let csrfFormFetch = {};
  let SQLQuery = { query: `SELECT * FROM csrfForm WHERE srfId = ${id}` };

  await axiosWithToken
    .post(BASE_URL + `dynamic`,SQLQuery, {
      headers: { requestType: "fetchData" },
    })
    .then((res) => {
      let resDatas = res?.data?.[0];
      if (resDatas) {
        csrfFormFetch = resDatas;
      }
    })
    .catch((error) => {
      console.log("Something Went Wrong!");
    });

  return csrfFormFetch;
};

export const generateSRFRange = (rangeString, srfDetails) => {
  let result = [];
  let ranges = rangeString?.split(",");

  if (srfDetails?.calType != 1) return;

  ranges?.forEach((range) => {
    let [start, end] = range?.split("-").map(Number);
    for (let i = start; i <= end; i++) {
      // Extract prefix from serviceReqNumber
      const parts = srfDetails?.serviceReqNumber?.split("/") || [];
      const prefix = parts?.slice(0, -1)?.join("/");
      result.push(prefix ? `${prefix}/${i}` : i);
    }
  });
  return result;
};

export const fetchSRFList = async () => {
  let srfList = {};
  await axiosWithToken
    .post(BASE_URL + `dynamic`,{
      query : "select id, serviceReqNumber, calType from srfs where status = 1 and calType = 1"
    })
    .then((res) => {
        srfList = res.data;
    })
    .catch((error) => {
      console.log("Something Went Wrong!");
    });
  return srfList;
};

export const fetchReservefromandto = async () => {
  let srfList = [];
  await axiosWithToken
    .post(BASE_URL + `dynamic`, {
      query:
        "SELECT * from reservedSrfSeries where status = 1 ORDER BY id DESC;",
    })
    .then((res) => {
      srfList = res.data;
    })
    .catch((error) => {
      console.log("Something Went Wrong!");
    });
  return srfList;
};
